<script setup lang="ts">

import { toTypedSchema } from '@vee-validate/zod';
import { useForm } from 'vee-validate';

import InvoiceDataForm from '~/blocks/InvoiceDataForm.vue';
import * as invoiceSchema from '~/schemas/invoiceDataForm.schema';

const form = useForm({
  validationSchema: toTypedSchema(invoiceSchema.getSchema()),
});

const submit = async () => {
  try {
    const outForm = await form.validate();
    console.log(outForm);
  } catch (error) {
    console.error(error);
  }
};

</script>

<template>
  <div class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-vertical">
          <div class="column">
            <pre>
              {{ form.values }}
              --
              {{ form.errors }}
            </pre>
            <InvoiceDataForm :form="form" />
            <button
              @click="submit"
              class="button is-primary is-large"
              type="submit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
